<template>
  <div>
    <div class="fpWarp">
      <div class="inner">
        <div class="title">
          <img src="//cdn1.zygames.com/qqsm/Public/img/version/mffl.png" />
          <div class="title-z4">
            <h1>商城道具<strong>疯狂送</strong></h1>
            <p>{{freePropsData.pageDate}}</p>
          </div>
        </div>
        <div class="content">
          <h3>活动内容:</h3>
          <p>活动期间，玩家可在游戏内商城中免费购买、使用以下商品:</p>
        </div>
        <div class="bottom-pic">
          <dl class="dl_all">
            <dd class="all_tit">
              <span>所有
                <br />用户</span>
            </dd>
            <dt
              v-for="(item,index) in freePropsData.allPeople" :key="index">
              <img :src="getImg(item)">
              <p>{{item}}</p>
            </dt>
            <!-- <dt class="hou"></dt> -->
          </dl>
          <dl class="dl_vip">
            <dd class="vip_tit">
              <span>VIP专属
                <br />免费道具</span>
            </dd>
            <dt class="dt_vip"
              v-for="(item,index) in freePropsData.vip"
              :key="index"
            >
              <img :src="getImg(item)">
              <p>{{item}}</p>
            </dt>
            <!-- <dt class="hou"></dt> -->
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "freeProps",
  data() {
    return {
      // pageDate: "1月8日——1月28日",
      // allPeople: [
      //   'M249_SAW','退魔AA12','军灵AWP','精钢AK47','精钢FN57','移动装置'
      // ],
      // vip: ["高碳怒焰风暴", "钛钢UMP9", "破军光束剑"],
      freePropAllImg: Object.freeze([
        { id: "6001", name: "M249_SAW", src: "m249swa", divwidths: "lwidth" },
        { id: "4561", name: "退魔AA12", src: "tmaa12", divwidths: "lwidth" },
        { id: "5526", name: "军灵AWP", src: "jlawp", divwidths: "lwidth" },
        { id: "232509", name: "精钢AK47", src: "ak47", divwidths: "lwidth" },
        { id: "231581", name: "精钢FN57", src: "fn57", divwidths: "swidth" },
        { id: "236004", name: "高碳怒焰风暴", src: "nyfb", divwidths: "lwidth" },
        { id: "233543", name: "钛钢UMP9", src: "ump", divwidths: "swidth" },
        { id: "20001", name: "移动装置", src: "ydzz", divwidths: "swidth" },
        { id: "9012", name: "破军光束剑", src: "gsj", divwidths: "lwidth" },
        { id: "2006", name: "AUG", src: "AUG", divwidths: "lwidth" },
        { id: "6581", name: "破军HK21", src: "pj-hk21", divwidths: "lwidth" },
        { id: "1009", name: "毛瑟M1932", src: "m1932", divwidths: "swidth" },
        { id: "231009", name: "钛钢毛瑟M1932", src: "m1932", divwidths: "swidth" },
        { id: "233503", name: "精钢Hawker-1", src: "Hawker-1", divwidths: "swidth" },
        { id: "1018", name: "破军-守备官", src: "pj-sbg", divwidths: "swidth" },
        { id: "20011", name: "静音装置", src: "jyzz", divwidths: "swidth" },
        { id: "1003", name: "USP", src: "usp", divwidths: "swidth" },
        { id: "2901", name: "破军AN94", src: "pj-an94", divwidths: "lwidth" },
        { id: "3543", name: "魔煞UMP9", src: "msump9", divwidths: "swidth" },
        { id: "235621", name: "精钢QBU88", src: "qbu88", divwidths: "lwidth" },
        { id: "20041", name: "力量增幅器", src: "llzf", divwidths: "swidth" },
        { id: "234602", name: "高碳QBS09", src: "v-qbs09", divwidths: "lwidth" },
        { id: "236581", name: "钛钢HK21", src: "v-hk21", divwidths: "lwidth" },
        { id: "钛钢HK416", name: "钛钢HK416", src: "416", divwidths: "lwidth" },
        { id: "231521", name: "高碳M29", src: "v-m29", divwidths: "swidth" }
      ])
    }
  },
  created() {
    this.getImg();
  },
  computed:{ 
    ...mapGetters(['freePropsData'])
  },
  methods: {
    getImg(str = "M249_SAW") {
      let imgSrc = "";
      this.freePropAllImg.forEach(function(value) {
        if (value.name == str) {
          imgSrc = value.src;
          // imgSrc = value.id;
        }
      });
      if (imgSrc) {
        // console.log(str,imgSrc);
        // return require("../assets/img/images/"+imgSrc+".png");
        return "//cdn1.zygames.com/qqsm/Public/img/version/freeProps/"+imgSrc+".png";
      } else {
        // console.log(str)
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.fpWarp {
  background: url("//cdn1.zygames.com/qqsm/Public/img/version/bg6.jpg") no-repeat top center;
  height: 1080px;
  position: relative;
  min-width: 1200px;
  .title {
    padding-top: 66px;
    .title-z4 {
      color: #333;
      margin-top: -50px;
      text-align: center;
      h1 {
        font: normal 32px/46px "Microsoft YaHei";
        color: #333;
        strong {
          font-weight: bold;
        }
      }
      p {
        font: normal 24px/30px "Microsoft YaHei";
        color: #333;
        margin-top: 6px;
      }
    }
  }
  .content {
    width: 500px;
    text-align: center;
    font-size: 20px;
    margin-top: 40px;
    margin-left: 360px;
    p {
      font-size: 16px;
    }
  }
  .bottom-pic {
    padding-top: 50px;
    dl {
      width: 1200px;
      overflow: hidden;
      dt {
        background: rgba($color: #eee, $alpha: 0.5);
        filter: progid:DXImageTransform.Microsoft.Alpha(opacity=70);
        float: left;
        width: 290px;
        height: 198px;
        margin-right: 10px;
        margin-bottom: 10px;
        &.dt_vip{
          background: rgba(255, 243, 199, 0.5);
        }
        img {
          display: block;
          margin-top: 20px;
          margin-left: auto;
          margin-right: auto;
        }
        p {
          color: #000;
          margin-right: 10px;
          margin-bottom: 10px;
          text-align: right;
          font-size: 16px;
        }
      }
      dd {
        float: left;
        font-size: 32px;
        color: #fff;
        width: 300px;
        height: 198px;
        opacity: 1;
        filter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);
        font-weight: 700;
        text-align: center;
        vertical-align: middle;
        // padding-top: 25px;
        span {
          // top:0;left:0;right:0;bottom:0;
          display: block;
          margin: 30px 0 0 0;
        }
      }
      dd.all_tit {
        background: #c33;
      }
      dd.vip_tit {
        background: #e90;
      }
      dt.hou {
        background: #a2a2a2;
        width: 290px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/freeProps.vue